import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useNavigate, useLocation } from "react-router-dom";
import TopLogo from '../../components/layout/TopLogo';
import TopBanner from '../../components/layout/TopBanner';
import rewardBtn from "../../assets/images/reward-btn.svg";
import myCouponBtn from "../../assets/images/my-coupon-btn.svg";
import noPrize from '../../assets/images/no-prize.png';
import PrimaryButtonSmall from "../../components/button/PrimaryButtonSmall";
import SecondaryButtonSmall from "../../components/button/SecondaryButtonSmall";
import { useDispatch, useSelector } from 'react-redux';
import { setMember } from "../../features/MemberSlice";

import TopBtn from "../../components/layout/TopBtnMember";
import { SearchPrize } from "../../services/Prize";
import prizeDefault from '../../assets/images/haier-prize-default.png';


export default function PrizeList() {

    const initialLoadMore = {
        limit: 100,
        offset: 0,
    }

    const { state } = useLocation();
    const store = useSelector((state) => state.member)

    const [prizeList, setPrizeList] = React.useState([]);
    const [prizeHistoryList, setPrizeHistoryList] = React.useState([])


    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isListActive, setIsListActive] = React.useState(null);
    const [isHistoryActive, setIsHistoryActive] = React.useState(null);


    const [loadMore, setLoadmore] = React.useState(initialLoadMore);



    React.useEffect(() => {
        if (state && state.isHistory) {
            setIsListActive(false)
            setIsHistoryActive(true)
        } else {
            setIsListActive(true)
            setIsHistoryActive(false)
        }
    }, []);

    async function getSearchPrize() {
        const { offset, limit } = loadMore
        let payload = {
            memberId: store['memberId'],
            mode: isListActive ? 1 : 2,
            limit: limit,
            offset: offset,
        }
        return await SearchPrize({
            data: payload
        })
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    let data = response.data.body.rewards
                    if (isListActive) {
                        setPrizeList(data)
                    } else {
                        setPrizeHistoryList(data)
                    }

                } else {
                    setPrizeList([])
                    setPrizeHistoryList([])
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }


    function fnSetData(name, value) {
        const tmpObj = {};
        tmpObj[name] = value;
        dispatch(setMember(tmpObj));
    }

    useEffect(() => {
        if (isListActive !== null)
            getSearchPrize()
    }, [isListActive]);


    return (
        <div id="shop-page">
            <TopLogo />
            <TopBanner type="memberPrivilage" />
            {/*<img src={ShopBanner} alt="shopbanner" className="w-full" />*/}
            <div id="shop" style={{
                // backgroundImage: `url(${background})`,
                minHeight: "220px",
                padding: "20px",
            }}
                className="bg-white px-[20px] mt-[-40px]">
                <TopBtn type="coupon"></TopBtn>

                <div className="grid grid-cols-2 px-[20px]">
                    <div style={{ borderRight: "2px #0A4197 solid" }} onClick={() => {
                        navigate('/member-coupon')
                    }}>
                        <img className="bg" style={{ margin: "auto" }} src={myCouponBtn} alt="Snow" />
                    </div>
                    <div>
                        <img className="bg" style={{ margin: "auto" }} src={rewardBtn} alt="Snow" />
                        <div className="blue-line w-[83px] mt-[5px]" style={{ marginInline: "auto" }} ></div>
                    </div>
                </div>

            </div>
            <div className="bg-lightBlue2" style={{
                minHeight: "calc(100vh - 360px)",
                height: "fit-content",
                padding: "15px",
            }}>

                <div className="grid grid-cols-2 rounded-full h-[32px] bg-white">
                    <div className={isListActive ? "rounded-full bg-lightBlue" : "rounded-full"}>
                        <div className="w-fit mt-[2%] mx-auto">
                            <button className={isListActive ? "text-white" : "text-blue"}
                                onClick={() => {
                                    setIsListActive(true)
                                    setIsHistoryActive(false)
                                }}
                            >รางวัลทั้งหมด</button>
                        </div>
                    </div>
                    <div className={isHistoryActive ? "rounded-full bg-lightBlue" : "rounded-full"}>
                        <div className="w-fit mt-[2%] mx-auto">
                            <button className={isHistoryActive ? "text-white" : "text-blue"}
                                onClick={() => {
                                    setIsListActive(false)
                                    setIsHistoryActive(true)
                                }}
                            >ประวัติรางวัล</button>
                        </div>
                    </div>
                </div >

                {isListActive &&
                    <div>
                        <div className="grid grid-cols-2 gap-[10px] mt-[20px] mx-[20px]">
                            {Array.isArray(prizeList) && prizeList.length > 0 && prizeList.map((item, index) => (
                                <div key={index}>
                                    <div className="bg-white h-[200px] relative">
                                        {item.picture ? (
                                            <img className="mx-auto h-[107px] w-[155px]" src={item.picture} alt="Snow" />
                                        ) :
                                            <img className="mx-auto h-[107px] w-[155px]" src={prizeDefault} alt="Snow" />
                                        }

                                        <div className="mx-[15px] mt-[5px]">
                                            <p className="text-blue text-[16px] font-bold leading-[16px]">{item.name}</p>
                                            <p className="text-blue text-[12px]">รับได้ถึงวันที่: {dayjs(item.expireDate, 'YYYY-MM-DD HH:mm:ss').add(7, 'hours').format('DD/MM/YYYY')}</p>
                                        </div>

                                        <div className="w-fit mx-auto absolute left-0 right-0 bottom-[8px]">
                                            <PrimaryButtonSmall className="w-[91px] small-btn"
                                                onClick={() => {
                                                    navigate("/prize-detail",
                                                        {
                                                            state: item.id
                                                        })
                                                }}>รับรางวัล</PrimaryButtonSmall>
                                        </div>
                                    </div>
                                </div>))
                            }
                        </div>

                        {Array.isArray(prizeList) && prizeList.length === 0 &&
                            <div className="mt-[60px]">
                                <img className="mx-[24%] w-[65%] opacity-30" src={noPrize} alt="Snow" />
                                <div className="text-center">
                                    <p className="mx-auto text-[14px] text-white">
                                        ยังไม่มีรางวัลพิเศษ
                                    </p>
                                </div>
                            </div>
                        }
                    </div>
                }

                {isHistoryActive &&
                    <div><div className="grid grid-cols-2 gap-[5px] mt-[20px] mx-[20px]">
                        {Array.isArray(prizeHistoryList) && prizeHistoryList.length > 0 && prizeHistoryList.map((item, index) => (
                            <div key={index}>
                                <div className="bg-white h-[200px] relative">
                                    {item.picture ? (
                                        <img className="mx-auto h-[107px]" src={item.picture} alt="Snow" />
                                    ) :
                                        <img className="mx-auto h-[107px]" src={prizeDefault} alt="Snow" />
                                    }

                                    <div className="mx-[15px] mt-[5px]">
                                        <p className="text-blue text-[16px] font-bold leading-[16px]">{item.name}</p>
                                        <p className="text-blue text-[12px]">รับได้ถึงวันที่: {dayjs(item.expireDate, 'YYYY-MM-DD HH:mm:ss').add(7, 'hours').format('DD/MM/YYYY')}</p>
                                    </div>

                                    <div className="w-fit mx-auto absolute left-0 right-0 bottom-[8px]">
                                        <SecondaryButtonSmall
                                            variant="outlined"
                                            className="w-[121px] small-btn"
                                            onClick={() => {
                                                navigate("/prize-history", { state: item.id })
                                            }}>ดูรายละเอียด</SecondaryButtonSmall>
                                    </div>
                                </div>


                            </div>))
                        }
                    </div>

                        {Array.isArray(prizeHistoryList) && prizeHistoryList.length === 0 &&
                            <div className="mt-[60px]">
                                <img className="mx-[24%] w-[65%] opacity-30" src={noPrize} alt="Snow" />
                                <div className="text-center">
                                    <p className="mx-auto text-[14px] text-white">
                                        ยังไม่มีรางวัลพิเศษ
                                    </p>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        </div >
    )
}